/*! @name @videojs-microsoft/videojs-pluginfactory @version 1.0.44 @license MIT */
import _assertThisInitialized$2 from '@babel/runtime/helpers/assertThisInitialized';
import _inheritsLoose$3 from '@babel/runtime/helpers/inheritsLoose';
import videojs from 'video.js';
import document$1 from 'global/document';

/*! @name @videojs-microsoft/videojs-freewheel @version 1.7.2 @license MIT */
var dom = videojs.dom;
var Component = videojs.getComponent('Component');
/**
 * This component generates a dom element with the label 'Ad' and the remaining time.
 */

var AdLabel = /*#__PURE__*/function (_Component) {
  _inheritsLoose$3(AdLabel, _Component);
  /**
    * Create a AdLabel component instance.
    *
    * @param  {Player} player
    *         A Video.js Player instance.
    *
    * @param  {Object} [options]
    *         An optional options object.
    *
    *         While not a core part of the Video.js plugin architecture, a
    *         second argument of options is a convenient way to accept inputs
    *         from your plugin's caller.
    */


  function AdLabel(player, options) {
    var _this;

    _this = _Component.call(this, player, options) || this;
    _this.adTitle = options.adTitle;
    _this.adUpNext = options.adUpNext;

    var updateAdLabelHandler = _this.updateAdLabelText.bind(_assertThisInitialized$2(_this));

    _this.on(player, ['loadstart', 'timeupdate'], updateAdLabelHandler);

    _this.on('dispose', function () {
      player.off(['loadstart', 'timeupdate'], updateAdLabelHandler);
    });

    return _this;
  }
  /**
    * Create the DOM element that will host ad label text.
    *
    * @return {Element} DOM element with ad label text
    */


  var _proto = AdLabel.prototype;

  _proto.createEl = function createEl() {
    var el = _Component.prototype.createEl.call(this, 'div', {
      className: 'vjs-freewheel-ad-label vjs-time-control',
      innerHTML: "<span role=\"presentation\">" + this.options().adTitle + " </span>"
    });

    this.contentEl_ = dom.createEl('span');
    el.appendChild(this.contentEl_);
    return el;
  }
  /**
    * Update ad label text.
    */
  ;

  _proto.updateAdLabelText = function updateAdLabelText() {
    var _this2 = this;

    if (!this.player().freewheel().adsPlaying) {
      return;
    }

    var duration = this.player().el().getElementsByTagName('video')[0].duration;
    var time = Math.floor(duration) - Math.floor(this.player().currentTime());
    var timeFormatted = this.timeFormat(time, 600);

    if (this.contentEl_ && this.contentEl_.innerText === timeFormatted) {
      return;
    }

    this.requestAnimationFrame(function () {
      if (!_this2.contentEl_) {
        return;
      }

      var oldNode = _this2.textNode_;
      _this2.textNode_ = document.createTextNode(timeFormatted + " - " + _this2.adUpNext + " \"" + _this2.player().options().title + "\"");

      if (!_this2.textNode_) {
        return;
      }

      if (oldNode) {
        _this2.contentEl_.replaceChild(_this2.textNode_, oldNode);
      } else {
        _this2.contentEl_.appendChild(_this2.textNode_);
      }
    });
  }
  /**
   * Format seconds as a time string, H:MM:SS or M:SS. Supplying a guide (in
   * seconds) will force a number of leading zeros to cover the length of the
   * guide.
   *
   * @param  {number} seconds
   *         Number of seconds to be turned into a string
   *
   * @param  {number} guide
   *         Number (in seconds) to model the string after
   *
   * @return {string}
   *         Time formatted as H:MM:SS or M:SS
   */
  ;

  _proto.timeFormat = function timeFormat(seconds, guide) {
    seconds = seconds < 0 ? 0 : seconds;
    var s = Math.floor(seconds % 60);
    var m = Math.floor(seconds / 60 % 60);
    var h = Math.floor(seconds / 3600);
    var gm = Math.floor(guide / 60 % 60);
    var gh = Math.floor(guide / 3600); // handle invalid times

    if (isNaN(seconds) || seconds === Infinity) {
      // '-' is false for all relational operators (e.g. <, >=) so this setting
      // will add the minimum number of fields specified by the guide
      h = m = s = '-';
    } // Check if we need to show hours


    h = h > 0 || gh > 0 ? h + ':' : ''; // If hours are showing, we may need to add a leading zero.
    // Always show at least one digit of minutes.

    m = ((h || gm >= 10) && m < 10 ? '0' + m : m) + ':'; // Check if leading zero is need for seconds

    s = s < 10 ? '0' + s : s;
    return h + m + s;
  };

  return AdLabel;
}(Component);

var dom$1 = videojs.dom;
var Component$1 = videojs.getComponent('Component');
var defaults = {};
/**
 * This component generates a dom element to allow a countdown and eventual button to skip ads
 */

var AdSkipper = /*#__PURE__*/function (_Component) {
  _inheritsLoose$3(AdSkipper, _Component);
  /**
   * Create a AdSkipper component instance.
   *
   * @param  {Player} player
   *         A Video.js Player instance.
   *
   * @param  {Object} [options]
   *         An optional options object.
   *
   *         While not a core part of the Video.js plugin architecture, a
   *         second argument of options is a convenient way to accept inputs
   *         from your plugin's caller.
   */


  function AdSkipper(player, options) {
    var _this;

    _this = _Component.call(this, player, options) || this;
    _this.options = videojs.mergeOptions(defaults, options);

    var updateTimeoutHandler = _this.updateTimeoutLabel.bind(_assertThisInitialized$2(_this));

    _this.on(player, ['loadstart', 'timeupdate'], updateTimeoutHandler);

    _this.on('dispose', function () {
      player.off(['loadstart', 'timeupdate'], updateTimeoutHandler);
    });

    return _this;
  }
  /**
   * Create the DOM element that will host ad label text.
   *
   * @return {Element} DOM element with ad label text
   */


  var _proto = AdSkipper.prototype;

  _proto.createEl = function createEl() {
    var posterUrl = this.player().poster();

    var el = _Component.prototype.createEl.call(this, 'div', {
      className: 'vjs-freewheel-adskipper',
      innerHTML: "<span class=\"adskipper-text\">" + this.options().skipText + " <span class=\"vjs-icon-next-item\"></span></span><img class=\"adskipper-image\" src=\"" + posterUrl + "\"><span class=\"adskipper-timer\">" + this.options().skipAdDelay + "</span>"
    });

    return el;
  }
  /**
   * Update ad label text.
   */
  ;

  _proto.updateTimeoutLabel = function updateTimeoutLabel() {
    if (!this.timeoutEl) {
      this.timeoutEl = dom$1.$('.adskipper-timer', '.vjs-freewheel-adskipper');
    }

    if (this.timeoutEl) {
      this.timeoutEl.innerText = this.options.skipAdDelay;
    }
  };

  return AdSkipper;
}(Component$1);

var version = "1.7.2";
var Plugin = videojs.getPlugin('plugin'); // Default options for the plugin.

var defaults$1 = {
  debug: false,
  timeoutSeconds: 5,
  skipAdLength: 30,
  skipAdDelay: 5,
  skipText: 'Skip Ad'
}; // VideoJS Event Constant Key Names

var eventPlay = 'play';
var eventPlaying = 'playing';
var eventPause = 'pause';
var eventEnded = 'ended';
var eventTimeupdate = 'timeupdate';
var eventContentchanged = 'contentchanged'; // Freewheel Constant Key Names

var fwFufAssetId = 'FUFASSETID';
var fwAdTech = 'msn_player_tech';
var fwAdViewIndex = 'msn_viewability_index';
var fwAdPageType = 'msn_page_type';
var fwAdRidPv = 'msn_rid_pv';
var fwAdProviderId = 'msn_provider'; // Freewheel Constant Values

var fwAdTechDefaultValue = 'html5';
var fwAdPageTypeDefaultValue = 'channelplayerpage';
/**
 * A plugin for VideoJS to support the FreeWheel video ad network.
 */

var Freewheel = /*#__PURE__*/function (_Plugin) {
  _inheritsLoose$3(Freewheel, _Plugin);
  /**
   * Create a Freewheel plugin instance.
   *
   * @param  {Player} player
   *         A Video.js Player instance.
   *
   * @param  {Object} [options]
   *         An optional options object.
   */


  function Freewheel(player, options) {
    var _this; // the parent class will add player under this.player


    _this = _Plugin.call(this, player) || this;
    _this.isReady = false;
    _this.adsPlaying = false;
    _this.valid = false;
    _this.options = videojs.mergeOptions(defaults$1, options); // Confirm valid timeout value, min 5 seconds

    _this.options.timeoutSeconds = _this.options.timeoutSeconds || defaults$1.timeoutSeconds; // Get events from the player instances

    var playerStateChangedHandler = _this._playerStateChanged.bind(_assertThisInitialized$2(_this));

    _this.on(player, [eventPlay, eventPlaying, eventPause, eventEnded, eventTimeupdate, eventContentchanged], playerStateChangedHandler); // Check if Freewheel AdManager.js has been included


    if (window.tv === undefined || window.tv.freewheel === undefined || window.tv.freewheel.SDK === undefined) {
      _this.log('Freewheel JavaScript (AdManager.js) Library Not Found, please include it before this plugin.');

      return _assertThisInitialized$2(_this);
    }

    var fwSDKLog = window.tv.freewheel.SDK.log;
    var fwSDKWarn = window.tv.freewheel.SDK.warn;
    var fwPageType = _this.options.pageName || fwAdPageTypeDefaultValue; // Begin AdManager.js setup

    _this.adManager = new window.tv.freewheel.SDK.AdManager(); // Slot Management

    _this.adManager.prerolls = [];
    _this.adManager.overlays = [];
    _this.adManager.midrolls = [];
    _this.adManager.postrolls = []; // Check if the user has included the Freewheel network id

    if (_this.options.network === undefined) {
      _this.log('You require a value for the key (network) in the plugin options.');

      return _assertThisInitialized$2(_this);
    } // Check if the user has included the Freewheel server url


    if (_this.options.server === undefined) {
      _this.log('You require a value for the key (server) in the plugin options.');

      return _assertThisInitialized$2(_this);
    } // Clean up AdManager.js verbosity...


    window.tv.freewheel.SDK.log = _this.log.bind(_assertThisInitialized$2(_this));
    window.tv.freewheel.SDK.warn = _this.log.bind(_assertThisInitialized$2(_this));

    if (!_this.options.debug) {
      // Be quiet, we are not in debug mode
      window.tv.freewheel.SDK.setLogLevel(window.tv.freewheel.SDK.LOG_LEVEL_QUIET);
    } // Setup freewheel network and server parameters


    _this.adManager.setNetwork(_this.options.network);

    _this.adManager.setServer(_this.options.server); // Alter Player Controls For Ad Label / Ad Skipping


    var adLabel = _this.player.controlBar.addChild('AdLabel', {
      adTitle: _this.options.adString,
      adUpNext: _this.options.adUpNextString
    }, 1);

    var adSkipper = _this.adSkipper = _this.player.addChild('AdSkipper', {
      skipText: _this.options.skipText,
      skipAdDelay: _this.options.skipAdDelay
    }, 1); // The plugin setup is valid, continue


    _this.valid = true;
    _this.playInViewOnLoad = _this.isPlayerInView(); // Setup binded event handlers

    var self = _assertThisInitialized$2(_this);

    self._requestAdsCompleteHandler = _this._onRequestComplete.bind(_assertThisInitialized$2(_this));
    self._requestAdsSlotStartedHandler = _this._onSlotStarted.bind(_assertThisInitialized$2(_this));
    self._requestAdsSlotEndedHandler = _this._onSlotEnded.bind(_assertThisInitialized$2(_this));

    self._requestAdsErrorHandler = function (e) {
      self.log(e.message);
    };
    /**
     * @memberof FreeWheel
     * @member {string} pageType
     *         The current page type for ad request.
     * @instance
     */


    Object.defineProperty(_assertThisInitialized$2(_this), 'pageType', {
      get: function get() {
        return fwPageType;
      }
    });
    self.player.ready(function () {
      player.addClass('vjs-freewheel');
      player.addClass('vjs-waiting');
      self.requestAds();
    });
    self.on('dispose', function () {
      adLabel.dispose();
      adSkipper.dispose();
      self.adsPlaying = false;
      self.valid = false;
      self.off([eventPlay, eventPlaying, eventPause, eventEnded, eventTimeupdate, eventContentchanged], playerStateChangedHandler);
      self.adContext.removeEventListener(window.tv.freewheel.SDK.EVENT_REQUEST_COMPLETE, self._requestAdsCompleteHandler);
      self.adContext.removeEventListener(window.tv.freewheel.SDK.EVENT_SLOT_STARTED, self._requestAdsSlotStartedHandler);
      self.adContext.removeEventListener(window.tv.freewheel.SDK.EVENT_SLOT_ENDED, self._requestAdsSlotEndedHandler);
      self.adContext.removeEventListener(window.tv.freewheel.SDK.EVENT_ERROR, self._requestAdsErrorHandler);
      self.adManager = undefined;
      self.adContext = undefined;
      self.player.controlBar.removeChild(adLabel);
      self.player.controlBar.removeChild(adSkipper);
      self.player.removeClass('vjs-freewheel');
      self.player.removeClass('vjs-waiting');
      window.tv.freewheel.SDK.log = fwSDKLog;
      window.tv.freewheel.SDK.warn = fwSDKWarn;
    });
    return _this;
  }
  /**
   * Log a message to the console, generally turned off for production
   *
   * @param  {string} msg
   *         The message that would be logged.
   *
   * @param  {string} other
   *         Optional second message to include.
   */


  var _proto = Freewheel.prototype;

  _proto.log = function log(msg, other) {
    // The only way to detect if freewheel tried to play an ad video and failed, this is only a warning
    // Freewheel swallows the promise object so catch cannot be applied to the playback action.
    if (msg && msg.indexOf('Blocked by browser, need player to display a start button.') > -1) {
      this.autoPlayBlocked();
    }

    if (!this.options.debug) {
      return;
    }

    if (other === undefined) {
      other = '';
    } else {
      other = "; " + JSON.stringify(other);
    }
    /* eslint no-console: ['error', { allow: ['info'] }] */


    console.info("videojs-freewheel> " + msg + other);
  }
  /**
   * Request ads from Freewheel
   */
  ;

  _proto.requestAds = function requestAds() {
    if (!this.valid) {
      return;
    }

    this.mediaSource = this.player.currentSource(); // Create a new context to display an ad

    this.adContext = this.adManager.newContext(); // Asset Playtype

    var playtype = this.player.options().autoplay ? window.tv.freewheel.SDK.VIDEO_ASSET_AUTO_PLAY_TYPE_ATTENDED : window.tv.freewheel.SDK.VIDEO_ASSET_AUTO_PLAY_TYPE_NONE; // Profile

    this.adContext.setProfile(this.options.profile);
    this.adContext.setVideoAsset(this.options.assetId, this.options.runtime, this.options.network, null, playtype, Math.round(Math.random() * 100000));
    this.adContext.setSiteSection(this.options.siteSection, this.options.network, Math.round(Math.random() * 100000));
    this.adContext.setVisitor(this.options.visitorId); // Other settings from MSN Video

    this.adContext.addKeyValue(fwFufAssetId, this.options.assetId);
    this.adContext.addKeyValue(fwAdTech, (this.player.techName_ || fwAdTechDefaultValue).toLocaleLowerCase());
    this.adContext.addKeyValue(fwAdViewIndex, this.getViewabilityIndex());
    this.adContext.addKeyValue(fwAdPageType, this.pageType);
    this.adContext.addKeyValue(fwAdRidPv, this.options.activityId);
    this.adContext.addKeyValue(fwAdProviderId, this.options.providerId); // Video Base Bitrate

    this.adContext.setParameter(window.tv.freewheel.SDK.PARAMETER_DESIRED_BITRATE, '2250', window.tv.freewheel.SDK.PARAMETER_LEVEL_OVERRIDE); // KeyValuePair Stuff

    if (Array.isArray(this.options.kvp)) {
      for (var idx = 0; idx < this.options.kvp.length; idx++) {
        if (Array.isArray(this.options.kvp[idx]) && this.options.kvp[idx].length === 2) {
          this.adContext.addKeyValue(this.options.kvp[idx][0], this.options.kvp[idx][1]);
        }
      }
    } // Used for debugging FreeWheel usage


    if (this.options.debug && this.options.adTagUrl) {
      this.adContext.addKeyValue('csURL', this.options.adTagUrl);
      var newServerUrl = this.options.server + (this.options.server.indexOf('?') >= 0 ? '&' : '?') + 'cana=4260535,4260536,4260537';
      this.adManager.setServer(newServerUrl);
    } // Inventory Setup - Preroll Setup


    if (this.options.preroll !== undefined) {
      for (var _idx = 0; _idx < this.options.preroll.length; _idx++) {
        this.adContext.addTemporalSlot("Preroll_" + (_idx + 1), window.tv.freewheel.SDK.ADUNIT_PREROLL, 0);
      }
    } // Inventory Setup - Overlay Setup


    if (this.options.overlay !== undefined) {
      for (var _idx2 = 0; _idx2 < this.options.overlay.length; _idx2++) {
        var timeSlot = parseInt(this.options.overlay[_idx2], 10);
        this.adContext.addTemporalSlot("Overlay_" + (_idx2 + 1), window.tv.freewheel.SDK.ADUNIT_OVERLAY, timeSlot);
      }
    } // Inventory Setup - Midroll Setup


    if (this.options.midroll !== undefined) {
      for (var _idx3 = 0; _idx3 < this.options.midroll.length; _idx3++) {
        var _timeSlot = parseInt(this.options.midroll[_idx3], 10);

        this.adContext.addTemporalSlot("Midroll_" + (_idx3 + 1), window.tv.freewheel.SDK.ADUNIT_MIDROLL, _timeSlot);
      }
    } // Inventory Setup - Postroll Setup


    if (this.options.postroll !== undefined) {
      for (var _idx4 = 0; _idx4 < this.options.postroll.length; _idx4++) {
        this.adContext.addTemporalSlot("Postroll_" + (_idx4 + 1), window.tv.freewheel.SDK.ADUNIT_POSTROLL, this.options.runtime);
      }
    } // Context Events


    this.adContext.addEventListener(window.tv.freewheel.SDK.EVENT_REQUEST_COMPLETE, this._requestAdsCompleteHandler);
    this.adContext.addEventListener(window.tv.freewheel.SDK.EVENT_SLOT_STARTED, this._requestAdsSlotStartedHandler);
    this.adContext.addEventListener(window.tv.freewheel.SDK.EVENT_SLOT_ENDED, this._requestAdsSlotEndedHandler); // Add Error Logging

    if (this.options.debug) {
      this.adContext.addEventListener(window.tv.freewheel.SDK.EVENT_ERROR, this._requestAdsErrorHandler);
    } // Do not allow other ads to show controls


    this.adContext.setParameter(window.tv.freewheel.SDK.PARAMETER_RENDERER_VIDEO_DISPLAY_CONTROLS_WHEN_PAUSE, false, window.tv.freewheel.SDK.PARAMETER_LEVEL_GLOBAL); // Timeouts

    this.adContext.setParameter(window.tv.freewheel.SDK.PARAMETER_RENDERER_VIDEO_START_DETECT_TIMEOUT, this.options.timeoutSeconds * 1000, window.tv.freewheel.SDK.PARAMETER_LEVEL_GLOBAL);
    this.adContext.setParameter(window.tv.freewheel.SDK.PARAMETER_RENDERER_VIDEO_PROGRESS_DETECT_TIMEOUT, this.options.timeoutSeconds * 1000, window.tv.freewheel.SDK.PARAMETER_LEVEL_GLOBAL);
    this.adContext.registerVideoDisplayBase(this.player.id());
    this.adContext.submitRequest(this.options.timeoutSeconds);
  }
  /**
   * Helper method to play preroll ads.
   */
  ;

  _proto.playPrerollAds = function playPrerollAds() {
    if (!this.valid) {
      return;
    }

    this.log('playPrerollAds()');

    if (this.hasPrerollAds()) {
      this.currentAd = this.adManager.prerolls.shift();
      this.player.controls(false);
      this.currentAd.play();
    } else {
      this.player.controls(true);
      this.player.src(this.mediaSource);
      this.player.load();
      this.player.play().catch(this.autoPlayBlocked.bind(this));
    }
  }
  /**
   * Helper method to allow the easy check if there are any preroll ads to play.
   *
   * @return {boolean}
   *     Returns true if there is prerolls to play, or false if there is not.
   */
  ;

  _proto.hasPrerollAds = function hasPrerollAds() {
    return this.adManager.prerolls.length !== 0;
  }
  /**
   * Helper method to allow the easy check if there are any overlay ads to play.
   *
   * @return {boolean}
   *     Returns true if there is overlay to play, or false if there is not.
   */
  ;

  _proto.hasOverlayAds = function hasOverlayAds() {
    return this.adManager.overlays.length !== 0;
  }
  /**
   * Helper method to allow the easy check if there are any midroll ads to play.
   *
   * @return {boolean}
   *     Returns true if there is midroll to play, or false if there is not.
   */
  ;

  _proto.hasMidrollAds = function hasMidrollAds() {
    return this.adManager.midrolls.length !== 0;
  }
  /**
   * Helper method to allow the easy check if there are any postroll ads to play.
   *
   * @return {boolean}
   *     Returns true if there is postroll to play, or false if there is not.
   */
  ;

  _proto.hasPostrollAds = function hasPostrollAds() {
    return this.adManager.postrolls.length !== 0;
  }
  /**
   * Helper method to build the viewability index for this player.
   *
   * @return {string}
   *     Returns the viewability index as a string.
   */
  ;

  _proto.getViewabilityIndex = function getViewabilityIndex() {
    var index = this.playInViewOnLoad ? 1 : 0;
    index += this.player.muted() ? 0 : 1;
    index += this.pageType.toLowerCase() === 'channelplayerpage' ? 1 : 0;
    index += !this.player.options().autoplay ? 1 : 0;
    index += this.isPlayerInView() ? 1 : 0;
    return index.toString();
  }
  /**
   * Helper method to determine if the player is currently in view.
   *
   * @return {boolean}
   *     Returns true if the player is mostly visible, false if mostly hidden offscreen.
   */
  ;

  _proto.isPlayerInView = function isPlayerInView() {
    var bounding = this.player.el().getBoundingClientRect();
    return bounding.top >= 0 && bounding.left >= 0 && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) && bounding.right <= (window.innerWidth || document.documentElement.clientWidth);
  }
  /**
   * Helper to show regular player controls when ad is complete
   */
  ;

  _proto.showStandardControls = function showStandardControls() {
    this.hideAdSkipper();
    this.player.removeClass('vjs-controls-disabled');
    this.player.removeClass('vjs-adsplaying');
    this.player.controlBar.getChild('ProgressControl').enable();
    this.player.controlBar.getChild('AdLabel').hide();
    this.player.controlBar.getChild('SubsCapsButton').show();
    this.player.controlBar.getChild('FullscreenToggle').show();
    this.player.controlBar.getChild('CurrentTimeDisplay').show();
    this.player.controlBar.getChild('TimeDivider').show();
    this.player.controlBar.getChild('DurationDisplay').show();
    var qualitySelector = this.player.controlBar.getChild('QualitySelectorButton');

    if (qualitySelector) {
      qualitySelector.show();
    }
  }
  /**
   * Helper to hide regular player controls when ad is running
   */
  ;

  _proto.hideStandardControls = function hideStandardControls() {
    this.player.removeClass('vjs-controls-disabled');
    this.player.addClass('vjs-adsplaying');
    this.player.controlBar.getChild('ProgressControl').disable();
    this.player.controlBar.getChild('AdLabel').show();
    this.player.controlBar.getChild('SubsCapsButton').hide();
    this.player.controlBar.getChild('FullscreenToggle').hide();
    this.player.controlBar.getChild('CurrentTimeDisplay').hide();
    this.player.controlBar.getChild('TimeDivider').hide();
    this.player.controlBar.getChild('DurationDisplay').hide();
    var qualitySelector = this.player.controlBar.getChild('QualitySelectorButton');

    if (qualitySelector) {
      qualitySelector.hide();
    }
  }
  /**
   * Helper to hide regular AdSkipper component
   */
  ;

  _proto.hideAdSkipper = function hideAdSkipper() {
    this.adSkipper.removeClass('adskipper-enabled');
    this.adSkipper.removeClass('adskipper-timer');
  }
  /**
   * Helper to skip actual playing ad
   */
  ;

  _proto.skipAd = function skipAd() {
    if (this.adsPlaying) {
      this.adSkipper.off('click', this.skipAd.bind(this));
      this.hideAdSkipper();
      this.currentAd.stop();

      this._onSlotEnded({
        slot: this.currentAd
      });
    }
  }
  /**
   * Helper to check if we are allowed to skip the ad
   */
  ;

  _proto.checkAdSkip = function checkAdSkip() {
    var totalTime = Math.floor(this.currentAd.getTotalDuration());
    var currentTime = Math.floor(this.currentAd.getPlayheadTime());

    if (totalTime > this.options.skipAdLength && !this.isVpaid) {
      if (currentTime < this.options.skipAdDelay) {
        this.adSkipper.options.skipAdDelay = Math.floor(this.options.skipAdDelay - currentTime);
        this.adSkipper.off('click', this.skipAd.bind(this));
        this.adSkipper.addClass('adskipper-timer');
        this.adSkipper.removeClass('adskipper-enabled');
      } else {
        this.adSkipper.addClass('adskipper-enabled');
        this.adSkipper.removeClass('adskipper-timer');
        this.adSkipper.on('click', this.skipAd.bind(this));
      }
    }
  }
  /**
   * Helper to show the big play button if autoplay is blocked
   */
  ;

  _proto.autoPlayBlocked = function autoPlayBlocked() {
    this.showStandardControls();
    this.player.removeClass('vjs-hide-bigplaybutton');
  }
  /**
   * Helper to disable closed captions from the main video while ad playback occurs
   */
  ;

  _proto.disableCaptions = function disableCaptions() {
    var textTracks = this.player.textTracks();

    if (textTracks) {
      textTracks.tracks_.forEach(function (track, idx) {
        if (track.mode.toLowerCase() === 'showing') {
          this.currentCaptionIdx = idx;
          track.mode = 'disabled';
        }
      }, this);
    }
  }
  /**
   * Helper to enable closed captions previously disabled while ad playback occured
   */
  ;

  _proto.enableCaptions = function enableCaptions() {
    var textTracks = this.player.textTracks();

    if (textTracks && this.currentCaptionIdx >= 0 && textTracks[this.currentCaptionIdx]) {
      textTracks[this.currentCaptionIdx].mode = 'showing';
      delete this.currentCaptionIdx;
    }
  }
  /**
   * Handle VideoJS player state changes.
   *
   * @param  {Event} event
   *     The VideoJS player state change event object
   */
  ;

  _proto._playerStateChanged = function _playerStateChanged(event) {
    if (!this.valid) {
      return;
    }

    if (event.type === 'timeupdate') {
      if (!this.adsPlaying && this.hasOverlayAds()) {
        for (var i = 0; i < this.adManager.overlays.length; i++) {
          var slot = this.adManager.overlays[i];
          var slotTimePosition = slot.getTimePosition();
          var videoCurrentTime = this.player.currentTime();

          if (Math.abs(videoCurrentTime - slotTimePosition) < 0.5) {
            this.adManager.overlays.splice(i, 1);
            this.currentAd = slot;
            this.currentAd.play();
            return;
          }
        }
      } else if (!this.adsPlaying) {
        this.showStandardControls();
      } else if (this.adsPlaying) {
        this.checkAdSkip();
      }

      if (!this.adsPlaying && this.hasMidrollAds()) {
        for (var _i = 0; _i < this.adManager.midrolls.length; _i++) {
          var _slot = this.adManager.midrolls[_i];

          var _slotTimePosition = _slot.getTimePosition();

          var _videoCurrentTime = this.player.currentTime();

          if (Math.abs(_videoCurrentTime - _slotTimePosition) < 0.5) {
            this.adManager.midrolls.splice(_i, 1);
            this.player.pause();
            this.player.controls(false);
            this.currentTime = this.player.currentTime();
            this.currentAd = _slot;
            this.currentAd.play();
            return;
          }
        }
      }

      return;
    }

    this.log("_playerStateChanged(" + event.type + ")");

    if (event.type === 'play') {
      if (!this.adsPlaying && this.hasPrerollAds()) {
        this.playPrerollAds();
      } else if (this.adsPlaying) {
        this.hideStandardControls();
      }
    }

    if (this.adContext === null || !this.isReady) {
      // We do not report video playback events until the freewheel plugin is ready.
      return;
    }

    if (this.adsPlaying) {
      // If we are playing an ad, or there is a preroll ad in queue, we mark the
      // the content as stopped, even if it's playing/stopping/ending.
      this.adContext.setVideoState(window.tv.freewheel.SDK.VIDEO_STATE_STOPPED);
    } else if (event.type === 'playing') {
      // Only firing for content playback
      this.adContext.setVideoState(window.tv.freewheel.SDK.VIDEO_STATE_PLAYING);
    } else if (event.type === 'pause') {
      // Only firing for content pausing
      this.adContext.setVideoState(window.tv.freewheel.SDK.VIDEO_STATE_PAUSED);
    } else if (event.type === 'ended') {
      // Only firing for content ending
      this.adContext.setVideoState(window.tv.freewheel.SDK.VIDEO_STATE_COMPLETED);

      if (this.hasPostrollAds()) {
        this.currentAd = this.adManager.postrolls.shift();
        this.currentAd.play();
      }
    }
  }
  /**
   * Handle Freewheel ad server response.
   *
   * @param  {Event} event
   *     The Freewheel event object
   */
  ;

  _proto._onRequestComplete = function _onRequestComplete(event) {
    var player = this.player;
    this.log("_onRequestComplete(" + event.type + ")");
    this.isReady = true;

    if (event.success) {
      var wasPaused = player.paused();
      var loadedSlots = this.adContext.getTemporalSlots();
      player.pause();

      for (var idx = 0; idx < loadedSlots.length; idx++) {
        var slot = loadedSlots[idx];

        switch (slot.getTimePositionClass()) {
          case window.tv.freewheel.SDK.TIME_POSITION_CLASS_PREROLL:
            this.adManager.prerolls.push(slot);
            break;

          case window.tv.freewheel.SDK.TIME_POSITION_CLASS_OVERLAY:
            this.adManager.overlays.push(slot);
            break;

          case window.tv.freewheel.SDK.TIME_POSITION_CLASS_MIDROLL:
            this.adManager.midrolls.push(slot);
            break;

          case window.tv.freewheel.SDK.TIME_POSITION_CLASS_POSTROLL:
            this.adManager.postrolls.push(slot);
            break;
        }
      }

      this.trigger('adsloaded');

      if (player.autoplay() || !wasPaused) {
        if (this.hasPrerollAds()) {
          this.playPrerollAds();
        } else if (!wasPaused) {
          player.play();
        }
      }
    }

    player.removeClass('vjs-waiting');
  }
  /**
   * Handle Freewheel ad slot starting.
   *
   * @param  {Event} event
   *     The Freewheel slot started event object
   */
  ;

  _proto._onSlotStarted = function _onSlotStarted(event) {
    var adDuration = event.slot.getTotalDuration();
    var adInstances = event.slot.getAdInstances();

    if (!adDuration) {
      this.log('_onSlotStarted(NO_AD)');
      return;
    }

    this.disableCaptions();
    this.isVpaid = false;
    this.adsPlaying = true;
    this.currentAd = event.slot;

    if (adInstances.length && adInstances[0].getAllCreativeRenditions().length) {
      this.isVpaid = adInstances[0].getAllCreativeRenditions()[0].getCreativeApi().toLowerCase().indexOf('vpaid') >= 0;
    }

    this.log('_onSlotStarted()');
    this.trigger('adstart');
  }
  /**
   * Handle Freewheel ad slot ending.
   *
   * @param  {Event} event
   *     The Freewheel slot ended event object
   */
  ;

  _proto._onSlotEnded = function _onSlotEnded(event) {
    this.adsPlaying = false;
    this.isVpaid = false;
    this.currentAd = null;
    this.enableCaptions();
    this.showStandardControls();
    this.log('_onSlotEnded()');
    this.trigger('adcomplete');
    var positionClass = event.slot.getTimePositionClass();

    if (positionClass === window.tv.freewheel.SDK.TIME_POSITION_CLASS_OVERLAY) {
      return;
    } else if (positionClass === window.tv.freewheel.SDK.TIME_POSITION_CLASS_PREROLL) {
      this.playPrerollAds();
    } else if (positionClass === window.tv.freewheel.SDK.TIME_POSITION_CLASS_MIDROLL) {
      this.player.src(this.mediaSource);
      this.player.load();
      this.player.currentTime(this.currentTime);
      this.player.controls(true);
      this.player.play().catch(this.autoPlayBlocked.bind(this));
    }
  };

  return Freewheel;
}(Plugin); // Define default values for the plugin's `state` object here.


Freewheel.defaultState = {}; // Include the version number.

Freewheel.VERSION = version; // Register the ad label component

videojs.registerComponent('AdLabel', AdLabel);
videojs.registerComponent('AdSkipper', AdSkipper); // Register the plugin with video.js.

videojs.registerPlugin('freewheel', Freewheel);

/*! @name @videojs-microsoft/videojs-geofencing @version 1.0.3 @license MIT */
var version$1 = "1.0.3";
var Plugin$1 = videojs.getPlugin('plugin'); // Default options for the plugin.

var defaults$2 = {
  errors: {
    VIDEO_GEOFENCED: "We're sorry, this video cannot be played from your current location."
  },
  isGeofenced: false
};
/**
 * An advanced Video.js plugin. For more information on the API
 *
 * See: https://blog.videojs.com/feature-spotlight-advanced-plugins/
 */

var Geofencing = /*#__PURE__*/function (_Plugin) {
  _inheritsLoose$3(Geofencing, _Plugin);
  /**
   * Create a Geofencing plugin instance.
   *
   * @param  {Player} player
   *         A Video.js Player instance.
   *
   * @param  {Object} [options]
   *         An optional options object.
   *         errors: { VIDEO_GEOFENCED <string> } - message display when geofenced is true
   *         isGeofenced <boolean> - indicates if geofence should take effect
   */


  function Geofencing(player, options) {
    var _this; // the parent class will add player under this.player


    _this = _Plugin.call(this, player) || this;
    var opts = _this.options = videojs.mergeOptions(defaults$2, options);

    var handleGeofenced = function handleGeofenced() {
      if (opts.isGeofenced) {
        player.error(opts.errors.VIDEO_GEOFENCED);
        player.reset();
      }
    };

    player.on('loadeddata', handleGeofenced);
    player.on('ready', function () {
      player.addClass('vjs-geofencing');
    });
    return _this;
  }

  return Geofencing;
}(Plugin$1); // Define default values for the plugin's `state` object here.


Geofencing.defaultState = {}; // Include the version number.

Geofencing.VERSION = version$1; // Register the plugin with video.js.

videojs.registerPlugin('geofencing', Geofencing);

/*! @name @videojs-microsoft/videojs-microsoftnewsui @version 1.0.28 @license MIT */

/**
   * Creates a settings panel title
   *
   * @param {Player} player  - the player instance
   */

function addSettingsPanelTitle(player) {
  var trackSettingsPanel = player.getChild('textTrackSettings').el();

  if (trackSettingsPanel) {
    var componentsWrapper = trackSettingsPanel.getElementsByClassName('vjs-modal-dialog-content');

    if (componentsWrapper && componentsWrapper.length) {
      var titleElement = videojs.dom.createEl('div', {
        className: 'vjs-track-settings-title',
        textContent: 'Closed Captions [CC] Settings'
      });
      componentsWrapper[0].insertBefore(titleElement, componentsWrapper[0].firstChild);
    }
  }
}
/**
 * Helper function used to notify when a menu button triggers/hides a popup menu
 *
 * @param {MenuButton} button the button that should have the CSS class
 * @param {Player} player  - the player instance
 */


function addPopupNotifier(button, player) {
  button.on('click', function () {
    if (button.buttonPressed_) {
      player.trigger('popupOn');
    } else {
      player.trigger('popupOff');
    }
  });
  button.on('mouseenter', function () {
    player.trigger('popupOn');
  });
  button.on('mouseleave', function () {
    // Only remove the class when there are no menu buttons locked (it happens when you click on the menu button)
    if (!player.el().getElementsByClassName('vjs-lock-showing').length) {
      player.trigger('popupOff');
    }
  });
}

var Dom = videojs.dom;
var Component$2 = videojs.getComponent('Component'); // Default options for the component.

var defaults$3 = {
  display: 'auto'
};
/**
 * This component generates a dom element on top of current player to display title
 */

var TitleBar = /*#__PURE__*/function (_Component) {
  _inheritsLoose$3(TitleBar, _Component);
  /**
    * Create a TitleBar component instance.
    *
    * @param  {Player} player
    *         A Video.js Player instance.
    *
    * @param  {Object} [options]
    *           - {string} [title, optional], the default title
    *           - {boolean, string} [display], display mode
    *                true, always show
    *                false, always hide
    *                auto, display based on condition, such as title text is empty or not
    */


  function TitleBar(player, options) {
    var _this;

    var mergedOpts = videojs.mergeOptions(defaults$3, options);
    _this = _Component.call(this, player, mergedOpts) || this;
    player.titleBar = _assertThisInitialized$2(_this);

    _this.update();

    return _this;
  }
  /**
  * Create the DOM element that will host the title bar and title text.
  *
  * @return {Element} DOM element with title bar
  */


  var _proto = TitleBar.prototype;

  _proto.createEl = function createEl() {
    var textEl = Dom.createEl('div', {
      className: 'vjs-title-text'
    });

    if (this.options_.title) {
      textEl.innerText = this.options_.title;
    }

    var classnames = 'vjs-title-bar' + (this.options_.display === true ? '' : ' vjs-hidden');
    this.contentEl_ = Dom.createEl('div', {
      className: classnames
    });
    this.contentEl_.appendChild(textEl);
    return this.contentEl_;
  }
  /**
   * Update the title bar UI based on current state
   */
  ;

  _proto.update = function update() {
    if (this.options_.display === 'auto') {
      if (this.contentEl_.children.length > 0) {
        if (this.contentEl_.children[0].innerText) {
          this.removeClass('vjs-hidden');
        } else {
          this.addClass('vjs-hidden');
        }
      }
    }
  }
  /**
   * Get the current title text, or set title text
   *
   * @param {string} [value]
   * @return {string}
   */
  ;

  _proto.title = function title(value) {
    if (this.contentEl_.children.length > 0) {
      var el = this.contentEl_.children[0];

      if (value !== undefined) {
        el.innerText = value;
        this.update();
      }

      return el.innerText;
    }

    return undefined;
  };

  _proto.dispose = function dispose() {
    this.contentEl_ = null;

    _Component.prototype.dispose.call(this);
  };

  return TitleBar;
}(Component$2);

var version$2 = "1.0.28";
var dom$2 = videojs.dom;
var Component$1$1 = videojs.getComponent('Component');
/**
 * This component generates a dom element with the current player volume (from 0 to 100)
 */

var VolumeLabel = /*#__PURE__*/function (_Component) {
  _inheritsLoose$3(VolumeLabel, _Component);
  /**
    * Create a VolumeLabel component instance.
    *
    * @param  {Player} player
    *         A Video.js Player instance.
    *
    * @param  {Object} [options]
    *         An optional options object.
    *
    *         While not a core part of the Video.js plugin architecture, a
    *         second argument of options is a convenient way to accept inputs
    *         from your plugin's caller.
    */


  function VolumeLabel(player, options) {
    var _this;

    _this = _Component.call(this, player, options) || this;

    _this.on(player, ['loadstart', 'volumechange'], _this.updateVolumeLabel);

    return _this;
  }
  /**
    * Create the DOM element that will host the volume text.
   *
    * @return {Element} DOM element with volume text
    */


  var _proto = VolumeLabel.prototype;

  _proto.createEl = function createEl() {
    var volume = this.getVolumeAsPercentage();
    this.contentEl_ = dom$2.createEl('div', {
      className: 'vjs-volume-label',
      textContent: volume
    });
    return this.contentEl_;
  }
  /**
   * Updates the volume text with the current value
   */
  ;

  _proto.updateVolumeLabel = function updateVolumeLabel() {
    this.contentEl_.innerText = this.getVolumeAsPercentage().toString();
  }
  /**
    * Gets the player volume as percentage (0 - 100)
   *
    * @return {number} the current volume of the player from 0 to 100.
    */
  ;

  _proto.getVolumeAsPercentage = function getVolumeAsPercentage() {
    if (this.player_.muted()) {
      return 0;
    }

    return Math.round(this.player_.volume() * 100);
  };

  return VolumeLabel;
}(Component$1$1);

var Plugin$2 = videojs.getPlugin('plugin'); // Default options for the plugin.

var defaults$1$1 = {};
/**
 * An advanced Video.js plugin. For more information on the API
 *
 * See: https://blog.videojs.com/feature-spotlight-advanced-plugins/
 */

var MicrosoftNewsUI = /*#__PURE__*/function (_Plugin) {
  _inheritsLoose$3(MicrosoftNewsUI, _Plugin);
  /**
   * Create a MicrosoftNewsUI plugin instance.
   *
   * @param  {Player} player
   *         A Video.js Player instance.
   *
   * @param  {Object} [options]
   *         An optional options object.
   *
   *         While not a core part of the Video.js plugin architecture, a
   *         second argument of options is a convenient way to accept inputs
   *         from your plugin's caller.
   */


  function MicrosoftNewsUI(player, options) {
    var _this; // the parent class will add player under this.player


    _this = _Plugin.call(this, player) || this;
    _this.options = videojs.mergeOptions(defaults$1$1, options);

    if (!player.controlBar || !player.controlBar.volumePanel || !player.controlBar.volumePanel.volumeControl) {
      return _assertThisInitialized$2(_this);
    }

    var self = _assertThisInitialized$2(_this); // setup UI elements


    player.controlBar.volumePanel.volumeControl.addChild('VolumeLabel', {}, 0);
    player.on('ready', function () {
      self.initVolumeBar(player);
      addSettingsPanelTitle(player);
      addPopupNotifier(player.controlBar.subsCapsButton, player);
    });

    if (player.controlBar.progressControl) {
      var progressControl = player.controlBar.progressControl;
      progressControl.seekBar.on('click', function () {
        this.focus();
      });
      progressControl.on('click', function () {
        progressControl.seekBar.focus();
      });
    }

    player.on('popupOn', function () {
      player.addClass('vjs-toolbar-popup');
    });
    player.on('popupOff', function () {
      player.removeClass('vjs-toolbar-popup');
    });
    player.one('playing', function () {
      if (player.poster() !== '') {
        player.poster('');
      }

      player.addClass('vjs-hide-bigplaybutton');
    });
    player.on('loadstart', function () {
      player.addClass('vjs-show-spinner');
    });
    player.on(['loadedmetadata', 'error'], function () {
      player.removeClass('vjs-show-spinner');
    }); // Disable right click menu

    player.on('contextmenu', function (e) {
      e.preventDefault();
    });
    self.on('dispose', function () {
      var controlBar = self.player.controlBar;
      var titleBar = self.player.titleBar;

      if (controlBar && controlBar.volumePanel) {
        var volControl = controlBar.volumePanel.volumeControl;
        var volText = volControl.getChild('VolumeLabel');

        if (volText) {
          volControl.removeChild(volText);
          volText.dispose();
        }
      }

      if (titleBar) {
        titleBar.dispose();
      }
    });
    return _this;
  }
  /**
   * Initializes the volume bar. This is necessary to set it to 0% when the player starts muted.
   *
   * @todo This method is only necessary until they fix the bug on videojs side.
   * @param {Player} player - the player instance
   */


  var _proto = MicrosoftNewsUI.prototype;

  _proto.initVolumeBar = function initVolumeBar(player) {
    var volumeBar = player.controlBar.volumePanel.volumeControl.volumeBar;

    if (volumeBar) {
      volumeBar.update();
    }
  };

  return MicrosoftNewsUI;
}(Plugin$2); // Define default values for the plugin's `state` object here.


MicrosoftNewsUI.defaultState = {}; // Include the version number.

MicrosoftNewsUI.VERSION = version$2; // Register UI components

videojs.registerComponent('TitleBar', TitleBar);
videojs.registerComponent('VolumeLabel', VolumeLabel); // Register the plugin with video.js.

videojs.registerPlugin('microsoftnewsui', MicrosoftNewsUI);

/*! @name @videojs-microsoft/videojs-telemetry @version 1.0.6 @license MIT */

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var version$3 = "1.0.6";
var Plugin$3 = videojs.getPlugin('plugin'); // Translations for telemetry/videojs names

var translate = {}; // Default options for the plugin.

var defaults$4 = {};
/**
 * A telemetry plugin for Microsoft News's VideoJS system
 */

var Telemetry = /*#__PURE__*/function (_Plugin) {
  _inheritsLoose(Telemetry, _Plugin);
  /**
   * Create a Telemetry plugin instance.
   *
   * @param  {Player} player
   *         A Video.js Player instance.
   *
   * @param  {Object} [options]
   *         An optional options object.
   *
   *         While not a core part of the Video.js plugin architecture, a
   *         second argument of options is a convenient way to accept inputs
   *         from your plugin's caller.
   */


  function Telemetry(player, options) {
    var _this; // the parent class will add player under this.player


    _this = _Plugin.call(this, player) || this;
    _this.options = videojs.mergeOptions(defaults$4, options);
    _this.adTelemetryEnabled = _this.player.freewheel !== undefined && _this.player.freewheel().valid;

    _this.reset();

    _this.hookEvents();

    _this.player.ready(function () {
      _this.player.addClass('vjs-telemetry');

      _this.sendPlayerImpression();
    });

    return _this;
  }
  /**
   * Reset everything back to initial state.
   */


  var _proto = Telemetry.prototype;

  _proto.reset = function reset() {
    this.duration = 0;
    this.firstPlayed = false;
    this.bufferComplete = false;
    this.firstQuarter = false;
    this.secondQuarter = false;
    this.thirdQuarter = false;
  }
  /**
   * Hook events to signal to telemetry.
   */
  ;

  _proto.hookEvents = function hookEvents() {
    this.on(this.player, ['dispose'], this.reset.bind(this));
    this.on(this.player, ['durationchange'], this._handleDurationChange.bind(this));
    this.on(this.player, ['loadstart', 'timeupdate', 'play', 'playing', 'seeked', 'pause', 'ended', 'volumechange', 'fullscreenchange'], this._handlePlayerEvent.bind(this));

    if (this.adTelemetryEnabled) {
      this.on(this.player.freewheel(), ['adcomplete'], this._handlePlayerEvent.bind(this));
    }
  }
  /**
   * Handle an event from VideoJS
   *
   * @param  {Object} event
   *         The event object from VideoJS.
   */
  ;

  _proto._handlePlayerEvent = function _handlePlayerEvent(event) {
    var isAd = this.adTelemetryEnabled && this.player.freewheel().adsPlaying;

    if (event.type === 'play') {
      if (!isAd) {
        if (!this.firstPlayedContent) {
          event.type = 'ContentStart';
          this.firstPlayedContent = true;
        } else {
          // We only fire once!
          return;
        }
      } else if (isAd && !this.firstPlayedAd) {
        event.type = 'AdStart';
        this.firstPlayedAd = true;
      } else {
        return;
      }
    } else if (event.type === 'loadstart') {
      event.type = isAd ? 'AdLoaded' : 'ContentOpen';
    } else if (event.type === 'playing') {
      if (!this.hasPaused) {
        return;
      }

      event.type = isAd ? 'AdResume' : 'ContentResume';
    } else if (event.type === 'timeupdate') {
      if (!isAd && !this.bufferComplete && this.player.bufferedPercent() === 1) {
        this.bufferComplete = true;
        this.reportEvent('BufferComplete', {
          isAd: isAd
        });
      }

      var currentTime = +this.player.currentTime().toFixed(0);

      switch (currentTime) {
        case this.firstQuarter:
          this.firstQuarter = false;
          event.type = isAd ? 'Ad25Percent' : 'Content25Percent';
          break;

        case this.secondQuarter:
          this.secondQuarter = false;
          event.type = isAd ? 'Ad50Percent' : 'Content50Percent';
          break;

        case this.thirdQuarter:
          this.thirdQuarter = false;
          event.type = isAd ? 'Ad75Percent' : 'Content75Percent';
          break;

        default:
          return;
      }
    } else if (event.type === 'volumechange') {
      event.type = this.player.muted() ? 'Mute' : 'Unmute';
    } else if (event.type === 'fullscreenchange') {
      event.type = this.player.isFullscreen() ? 'FullScreenEnter' : 'FullScreenExit';
    } else if (event.type === 'pause') {
      this.hasPaused = true;
      event.type = isAd ? 'AdPause' : 'EventPause';
    } else if (event.type === 'ended') {
      event.type = isAd ? 'AdComplete' : 'ContentComplete';
    } else if (event.type === 'adcomplete') {
      this.hasPaused = false;
      this.adComplete = true;
    }

    var eventName = translate[event.type] || event.type;
    this.reportEvent(eventName, {
      isAd: isAd
    });
  }
  /**
   * Handle VideoJS's duration change
   */
  ;

  _proto._handleDurationChange = function _handleDurationChange() {
    this.duration = +this.player.duration().toFixed(0);

    if (this.duration > 0) {
      var quarterTime = (this.duration / 4).toFixed(0);
      this.firstQuarter = +quarterTime;
      this.secondQuarter = +quarterTime * 2;
      this.thirdQuarter = +quarterTime * 3;
    }
  }
  /**
   * Send the initial player impression
   */
  ;

  _proto.sendPlayerImpression = function sendPlayerImpression() {
    // Initial impression
    this.reportEvent('CommonPlayerImpression');
  }
  /**
   * Report a signal to the video player parent.
   *
   * @param  {string} eventName
   *         The name of the event signal.
   *
   * @param  {Object} extraData
   *         Optional extra data to include in the signal event.
   */
  ;

  _proto.reportEvent = function reportEvent(eventName, extraData) {
    var data = this.generateReport(extraData);
    this.player.trigger('telemetry', {
      name: eventName,
      data: data
    });
  }
  /**
   * Generate a report based on the what data the player has.
   *
   * @param  {Object} extraData
   *         Extra data to include in the report
   *
   * @return {Object}
   *         Returns a filled in report for the telemetry signal
   */
  ;

  _proto.generateReport = function generateReport(extraData) {
    var duration = this.player.duration();
    var report = {
      IsAd: extraData && extraData.isAd,
      PlayerInstanceId: this.player.id(),
      PlayerTechnology: 'HTML5',
      PlaybackStatus: this.player.readyState(),
      ErrorType: extraData && extraData.ErrorType,
      ErrorDesc: extraData && extraData.ErrorDesc,
      VideoPlayerType: 'mp4:progressive',
      VideoDuration: duration,
      VideoElapsedTime: this.player.currentTime(),
      SeekFrom: extraData && extraData.SeekFrom,
      SeekTo: extraData && extraData.SeekTo,
      VideoLength: duration * 1000,
      VideoSize: {
        w: this.player.videoWidth(),
        h: this.player.videoHeight()
      }
    };
    videojs.mergeOptions(report, extraData);
    return report;
  };

  return Telemetry;
}(Plugin$3); // Define default values for the plugin's `state` object here.


Telemetry.defaultState = {}; // Include the version number.

Telemetry.VERSION = version$3; // Register the plugin with video.js.

videojs.registerPlugin('telemetry', Telemetry);

/*! @name @videojs-microsoft/videojs-qualityselector @version 2.0.6 @license MIT */
/*! @name videojs-contrib-quality-levels @version 2.0.9 @license Apache-2.0 */

function _inheritsLoose$1(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}
/**
 * A single QualityLevel.
 *
 * interface QualityLevel {
 *   readonly attribute DOMString id;
 *            attribute DOMString label;
 *   readonly attribute long width;
 *   readonly attribute long height;
 *   readonly attribute long bitrate;
 *            attribute boolean enabled;
 * };
 *
 * @class QualityLevel
 */


var QualityLevel =
/**
 * Creates a QualityLevel
 *
 * @param {Representation|Object} representation The representation of the quality level
 * @param {string}   representation.id        Unique id of the QualityLevel
 * @param {number=}  representation.width     Resolution width of the QualityLevel
 * @param {number=}  representation.height    Resolution height of the QualityLevel
 * @param {number}   representation.bandwidth Bitrate of the QualityLevel
 * @param {Function} representation.enabled   Callback to enable/disable QualityLevel
 */
function QualityLevel(representation) {
  var level = this; // eslint-disable-line

  if (videojs.browser.IS_IE8) {
    level = document$1.createElement('custom');

    for (var prop in QualityLevel.prototype) {
      if (prop !== 'constructor') {
        level[prop] = QualityLevel.prototype[prop];
      }
    }
  }

  level.id = representation.id;
  level.label = level.id;
  level.width = representation.width;
  level.height = representation.height;
  level.bitrate = representation.bandwidth;
  level.enabled_ = representation.enabled;
  Object.defineProperty(level, 'enabled', {
    /**
     * Get whether the QualityLevel is enabled.
     *
     * @return {boolean} True if the QualityLevel is enabled.
     */
    get: function get() {
      return level.enabled_();
    },

    /**
     * Enable or disable the QualityLevel.
     *
     * @param {boolean} enable true to enable QualityLevel, false to disable.
     */
    set: function set(enable) {
      level.enabled_(enable);
    }
  });
  return level;
};
/**
 * A list of QualityLevels.
 *
 * interface QualityLevelList : EventTarget {
 *   getter QualityLevel (unsigned long index);
 *   readonly attribute unsigned long length;
 *   readonly attribute long selectedIndex;
 *
 *   void addQualityLevel(QualityLevel qualityLevel)
 *   void removeQualityLevel(QualityLevel remove)
 *   QualityLevel? getQualityLevelById(DOMString id);
 *
 *   attribute EventHandler onchange;
 *   attribute EventHandler onaddqualitylevel;
 *   attribute EventHandler onremovequalitylevel;
 * };
 *
 * @extends videojs.EventTarget
 * @class QualityLevelList
 */


var QualityLevelList = /*#__PURE__*/function (_videojs$EventTarget) {
  _inheritsLoose$1(QualityLevelList, _videojs$EventTarget);

  function QualityLevelList() {
    var _this;

    _this = _videojs$EventTarget.call(this) || this;

    var list = _assertThisInitialized(_assertThisInitialized(_this)); // eslint-disable-line


    if (videojs.browser.IS_IE8) {
      list = document$1.createElement('custom');

      for (var prop in QualityLevelList.prototype) {
        if (prop !== 'constructor') {
          list[prop] = QualityLevelList.prototype[prop];
        }
      }
    }

    list.levels_ = [];
    list.selectedIndex_ = -1;
    /**
     * Get the index of the currently selected QualityLevel.
     *
     * @returns {number} The index of the selected QualityLevel. -1 if none selected.
     * @readonly
     */

    Object.defineProperty(list, 'selectedIndex', {
      get: function get() {
        return list.selectedIndex_;
      }
    });
    /**
     * Get the length of the list of QualityLevels.
     *
     * @returns {number} The length of the list.
     * @readonly
     */

    Object.defineProperty(list, 'length', {
      get: function get() {
        return list.levels_.length;
      }
    });
    return list || _assertThisInitialized(_this);
  }
  /**
   * Adds a quality level to the list.
   *
   * @param {Representation|Object} representation The representation of the quality level
   * @param {string}   representation.id        Unique id of the QualityLevel
   * @param {number=}  representation.width     Resolution width of the QualityLevel
   * @param {number=}  representation.height    Resolution height of the QualityLevel
   * @param {number}   representation.bandwidth Bitrate of the QualityLevel
   * @param {Function} representation.enabled   Callback to enable/disable QualityLevel
   * @return {QualityLevel} the QualityLevel added to the list
   * @method addQualityLevel
   */


  var _proto = QualityLevelList.prototype;

  _proto.addQualityLevel = function addQualityLevel(representation) {
    var qualityLevel = this.getQualityLevelById(representation.id); // Do not add duplicate quality levels

    if (qualityLevel) {
      return qualityLevel;
    }

    var index = this.levels_.length;
    qualityLevel = new QualityLevel(representation);

    if (!('' + index in this)) {
      Object.defineProperty(this, index, {
        get: function get() {
          return this.levels_[index];
        }
      });
    }

    this.levels_.push(qualityLevel);
    this.trigger({
      qualityLevel: qualityLevel,
      type: 'addqualitylevel'
    });
    return qualityLevel;
  };
  /**
   * Removes a quality level from the list.
   *
   * @param {QualityLevel} remove QualityLevel to remove to the list.
   * @return {QualityLevel|null} the QualityLevel removed or null if nothing removed
   * @method removeQualityLevel
   */


  _proto.removeQualityLevel = function removeQualityLevel(qualityLevel) {
    var removed = null;

    for (var i = 0, l = this.length; i < l; i++) {
      if (this[i] === qualityLevel) {
        removed = this.levels_.splice(i, 1)[0];

        if (this.selectedIndex_ === i) {
          this.selectedIndex_ = -1;
        } else if (this.selectedIndex_ > i) {
          this.selectedIndex_--;
        }

        break;
      }
    }

    if (removed) {
      this.trigger({
        qualityLevel: qualityLevel,
        type: 'removequalitylevel'
      });
    }

    return removed;
  };
  /**
   * Searches for a QualityLevel with the given id.
   *
   * @param {string} id The id of the QualityLevel to find.
   * @return {QualityLevel|null} The QualityLevel with id, or null if not found.
   * @method getQualityLevelById
   */


  _proto.getQualityLevelById = function getQualityLevelById(id) {
    for (var i = 0, l = this.length; i < l; i++) {
      var level = this[i];

      if (level.id === id) {
        return level;
      }
    }

    return null;
  };
  /**
   * Resets the list of QualityLevels to empty
   *
   * @method dispose
   */


  _proto.dispose = function dispose() {
    this.selectedIndex_ = -1;
    this.levels_.length = 0;
  };

  return QualityLevelList;
}(videojs.EventTarget);
/**
 * change - The selected QualityLevel has changed.
 * addqualitylevel - A QualityLevel has been added to the QualityLevelList.
 * removequalitylevel - A QualityLevel has been removed from the QualityLevelList.
 */


QualityLevelList.prototype.allowedEvents_ = {
  change: 'change',
  addqualitylevel: 'addqualitylevel',
  removequalitylevel: 'removequalitylevel'
}; // emulate attribute EventHandler support to allow for feature detection

for (var event in QualityLevelList.prototype.allowedEvents_) {
  QualityLevelList.prototype['on' + event] = null;
}

var version$4 = "2.0.9";
var registerPlugin = videojs.registerPlugin || videojs.plugin;
/**
 * Initialization function for the qualityLevels plugin. Sets up the QualityLevelList and
 * event handlers.
 *
 * @param {Player} player Player object.
 * @param {Object} options Plugin options object.
 * @function initPlugin
 */

var initPlugin = function initPlugin(player, options) {
  var originalPluginFn = player.qualityLevels;
  var qualityLevelList = new QualityLevelList();

  var disposeHandler = function disposeHandler() {
    qualityLevelList.dispose();
    player.qualityLevels = originalPluginFn;
    player.off('dispose', disposeHandler);
  };

  player.on('dispose', disposeHandler);

  player.qualityLevels = function () {
    return qualityLevelList;
  };

  player.qualityLevels.VERSION = version$4;
  return qualityLevelList;
};
/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @param {Object} options Plugin options object
 * @function qualityLevels
 */


var qualityLevels = function qualityLevels(options) {
  return initPlugin(this, videojs.mergeOptions({}, options));
}; // Register the plugin with video.js.


registerPlugin('qualityLevels', qualityLevels); // Include the version number.

qualityLevels.VERSION = version$4;
var MenuItem = videojs.getComponent('MenuItem');
/**
 * The quality selector menu item
 *
 * @extends MenuButton
 */

var QualitySelectorMenuItem = /*#__PURE__*/function (_MenuItem) {
  _inheritsLoose$3(QualitySelectorMenuItem, _MenuItem);
  /**
    * Create a QualitySelectorMenuItem component instance.
    *
    * @param  {Player} player a Video.js Player instance.
    *
    * @param  {Object} [options] an optional options object.
    *          id - identifier of this item
    *          label - display text
    *          selectable - determine if selectable
    *          multiSelectable - support multi selection
    *          sourceUrl - url as source
    *          sourceType - type as source
    *          index - current index of item
    *          selected - indicate if item is selected
    */


  function QualitySelectorMenuItem(player, options) {
    var _this;

    options.selectable = true;
    options.multiSelectable = false;
    _this = _MenuItem.call(this, player, options) || this;
    _this.id = options.id;
    _this.label = options.label;

    if (options.sourceUrl) {
      _this.adaptiveStreaming = false;
      _this.sourceUrl = options.sourceUrl; // Is this intended behaviour?

      _this.sourceType = options.sourceType || 'video/mp4';
    } else {
      _this.adaptiveStreaming = true;
    }

    return _this;
  }
  /**
   * Updates the current menu item based on its current state
   */


  var _proto = QualitySelectorMenuItem.prototype;

  _proto.update = function update() {
    var selectedIndex = this.player_.qualityLevels().selectedIndex;
    this.selected(this.options_.index === selectedIndex);
  }
  /**
   * Any click on a `MenuItem` puts it into the selected state.
   * See {@link ClickableComponent#handleClick} for instances where this is called.
   *
   * @listens tap
   * @listens click
   */
  ;

  _proto.handleClick = function handleClick() {
    _MenuItem.prototype.handleClick.call(this);

    this.setQualityLevel();
  }
  /**
   * Sets the quality level based on the index specified in the options object. It also triggers a quality level change event.
   */
  ;

  _proto.setQualityLevel = function setQualityLevel() {
    var level = this.options_;
    var qualityLevels = this.player_.qualityLevels();

    for (var i = 0; i < qualityLevels.length; i++) {
      if (level.index === i) {
        qualityLevels[i].enabled = true;
        this.changeSource();
        this.triggerQualityLevelsChange(qualityLevels, i);
      } else {
        qualityLevels[i].enabled = false;
      }
    }
  }
  /**
   * Triggers a quality levels change event when the current index is different from the selected one.
   *
   * @param {QualityLevelList } qualityLevels - the quality levels object
   * @param {number} currentIndex - the new current index
   */
  ;

  _proto.triggerQualityLevelsChange = function triggerQualityLevelsChange(qualityLevels, currentIndex) {
    // This will trigger an update call on the menu
    if (qualityLevels.selectedIndex_ !== currentIndex) {
      qualityLevels.selectedIndex_ = currentIndex;
      qualityLevels.trigger({
        selectedIndex: currentIndex,
        type: 'change'
      });
    }
  }
  /**
   * Changes the source of the player in case it's different from the current one.
   */
  ;

  _proto.changeSource = function changeSource() {
    var player = this.player_;

    if (this.adaptiveStreaming) {
      // We do not action on adaptive streams
      return;
    }

    if (player.src() !== this.sourceUrl) {
      var currentTime = this.player_.currentTime();
      player.src({
        src: this.sourceUrl,
        type: this.sourceType
      });
      player.one('loadedmetadata', function () {
        player.currentTime(currentTime);
      });
    }
  };

  return QualitySelectorMenuItem;
}(MenuItem); // © Microsoft Corporation. All rights reserved.
// For now this is just a copy of the MicrosoftNewsUi addPopupNotifier. Please extract this into an NPM package and use it in both places (here and on
// the Microsoft News plugin).

/**
 * Helper function used to notify when a menu button triggers/hides a popup menu
 *
 * @param {MenuButton} button the button that should have the CSS class
 * @param {Player} player  - the player instance
 */


function addPopupNotifier$1(button, player) {
  button.on('click', function () {
    if (button.buttonPressed_) {
      player.trigger('popupOn');
    } else {
      player.trigger('popupOff');
    }
  });
  button.on('mouseenter', function () {
    player.trigger('popupOn');
  });
  button.on('mouseleave', function () {
    // Only remove the class when there are no menu buttons locked (it happens when you click on the menu button)
    if (!player.el().getElementsByClassName('vjs-lock-showing').length) {
      player.trigger('popupOff');
    }
  });
}

var MenuButton = videojs.getComponent('MenuButton');
/**
 * The button component for toggling and selecting captions and/or subtitles
 *
 * @extends MenuButton
 */

var QualitySelectorButton = /*#__PURE__*/function (_MenuButton) {
  _inheritsLoose$3(QualitySelectorButton, _MenuButton);
  /**
    * Create a QualitySelectorButton component instance.
    *
    * @param  {Player} player a Video.js Player instance.
    *
    * @param  {Object} [options] an optional options object.
    *          qualityId - the id used to select the quality level as default
    *          displayButtonText - indicate if should show button text
    *          videoFiles - video files associate to quality level menu items
    */


  function QualitySelectorButton(player, options) {
    var _this;

    if (options === void 0) {
      options = {};
    }

    _this = _MenuButton.call(this, player, options) || this;
    MenuButton.apply(_assertThisInitialized$2(_this), arguments);
    var changeHandler = videojs.bind(_assertThisInitialized$2(_this), _this.update);
    var qualityLevels = player.qualityLevels();
    qualityLevels.on(['change', 'addqualitylevel'], changeHandler); // Set initial level

    if (options.videoFiles !== null) {
      var level = _this.items.filter(function (x) {
        return x.id === options.qualityId;
      });

      if (level.length > 0) {
        level[0].setQualityLevel();
      } else if (options.videoFiles && options.qualityId) {
        var videofile = options.videoFiles.filter(function (x) {
          return x.id === options.qualityId;
        });

        if (videofile.length > 0) {
          _this.controlText(videofile[0].bitrateLabel || videofile[0].id);
        }
      }
    }

    addPopupNotifier$1(_assertThisInitialized$2(_this), player);

    _this.on('dispose', function () {
      qualityLevels.off(['change', 'addqualitylevel'], changeHandler);
    });

    return _this;
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string} The DOM `className` for this object.
   */


  var _proto = QualitySelectorButton.prototype;

  _proto.buildCSSClass = function buildCSSClass() {
    return "vjs-quality-sel-button " + _MenuButton.prototype.buildCSSClass.call(this) + " " + (this.options_.displayButtonText ? 'vjs-display-control-text' : '');
  }
  /**
   * Allows sub components to stack CSS class names for the wrapper element.
   *
   * @return {string} The constructed wrapper DOM `className`.
   */
  ;

  _proto.buildWrapperCSSClass = function buildWrapperCSSClass() {
    return "vjs-quality-sel-button " + _MenuButton.prototype.buildWrapperCSSClass.call(this);
  }
  /**
   * Update the menu based on the current state of its items.
   */
  ;

  _proto.update = function update() {
    var qualityLevels = this.player_.qualityLevels();

    if (qualityLevels.selectedIndex >= 0) {
      this.controlText(qualityLevels[qualityLevels.selectedIndex].label);
    }

    MenuButton.prototype.update.call(this);
  }
  /**
   * Create caption/subtitles menu items
   *
   * @return {CaptionSettingsMenuItem[]} The array of current menu items.
   */
  ;

  _proto.createItems = function createItems() {
    var levelToVideoMap = {};
    var items = [];
    var qualityLevels = this.player_.qualityLevels();
    var videoFiles = this.options_.videoFiles;

    if (videoFiles) {
      // Creating a map to avoid traversing the list multiple times
      for (var i = 0; i < videoFiles.length; i++) {
        levelToVideoMap[videoFiles[i].id] = videoFiles[i];
      }

      for (var _i = 0; _i < qualityLevels.length; _i++) {
        var selected = _i === qualityLevels.selectedIndex;
        var videoInfo = levelToVideoMap[qualityLevels[_i].id];
        items.push(new QualitySelectorMenuItem(this.player_, {
          id: videoInfo.id,
          label: videoInfo.bitrateLabel || videoInfo.id,
          selectable: true,
          multiSelectable: false,
          sourceUrl: videoInfo.url,
          sourceType: videoInfo.type,
          index: _i,
          selected: selected
        }));
      }

      return items;
    }

    for (var _i2 = 0; _i2 < qualityLevels.length; _i2++) {
      var _selected = _i2 === qualityLevels.selectedIndex;

      var qualityLevel = qualityLevels[_i2];
      var label = this.findLabelForLevel(qualityLevel);

      if (!label) {
        qualityLevel.enabled = false;
        continue;
      }

      items.push(new QualitySelectorMenuItem(this.player_, {
        id: label,
        label: qualityLevel.label = label,
        selectable: true,
        multiSelectable: false,
        index: _i2,
        selected: _selected
      }));
    }

    return items.reverse();
  }
  /**
   * Return the Label for the provided qualityLevel
   *
   * @param {Object} qualityLevel The quality to return the label for
   *
   * @return {string|boolean} The label for the quality level provided, or false if unknown.
  */
  ;

  _proto.findLabelForLevel = function findLabelForLevel(qualityLevel) {
    switch (qualityLevel.height) {
      case 1080:
        {
          return 'FHD';
        }

      case 720:
        {
          return 'HD';
        }

      case 540:
        {
          if (qualityLevel.bitrate > 2000000) {
            return 'HQ';
          }

          return 'SD';
        }

      case 360:
        {
          if (qualityLevel.bitrate > 1000000) {
            return 'LQ';
          }

          return 'LO';
        }

      default:
        {
          return false;
        }
    }
  }
  /**
   * Dispose the object
   */
  ;

  _proto.dispose = function dispose() {
    for (var i = 0; i < this.items.length; i++) {
      this.items[i].dispose();
    }

    _MenuButton.prototype.dispose.call(this);
  };

  return QualitySelectorButton;
}(MenuButton);

var version$1$1 = "2.0.6";
var Plugin$4 = videojs.getPlugin('plugin'); // Default options for the plugin.

var defaults$5 = {
  qualityId: 'HQ',
  displayButtonText: true,
  videoFiles: null
};
/**
 * An advanced Video.js plugin. For more information on the API
 *
 * See: https://blog.videojs.com/feature-spotlight-advanced-plugins/
 */

var QualitySelector = /*#__PURE__*/function (_Plugin) {
  _inheritsLoose$3(QualitySelector, _Plugin);
  /**
   * Create a QualitySelector plugin instance.
   *
   * @param  {Player} player
   *         A Video.js Player instance.
   *
   * @param  {Object} [options]
   *         An optional options object.
   *
   *         While not a core part of the Video.js plugin architecture, a
   *         second argument of options is a convenient way to accept inputs
   *         from your plugin's caller.
   */


  function QualitySelector(player, options) {
    var _this; // the parent class will add player under this.player


    _this = _Plugin.call(this, player) || this;
    _this.options = videojs.mergeOptions(defaults$5, options);

    if (_this.options.videoFiles) {
      if (_this.options.videoFiles.length <= 1) {
        return _assertThisInitialized$2(_this);
      }

      _this.videoFiles = _this.options.videoFiles.filter(function (x) {
        return x.bitrate > 0;
      });
    }

    var qualityChangeHandler = function (e) {
      var level = player.qualityLevels()[e.selectedIndex];
      this.trigger('qualityLevelChanged', {
        tolevel: {
          id: level.id,
          label: level.label,
          index: e.selectedIndex,
          bandwidth: level.bandwidth
        }
      });
    }.bind(_assertThisInitialized$2(_this));

    var addQualityLevelAdaptive = function (e) {
      this.menuButton.update();
    }.bind(_assertThisInitialized$2(_this));

    var addUi = function () {
      this.menuButton = this.player.controlBar.addChild('QualitySelectorButton', this.options);
      this.player.controlBar.el().insertBefore(this.menuButton.el(), this.player.controlBar.volumePanel.el().nextSibling);
    }.bind(_assertThisInitialized$2(_this));

    _this.player.ready(function () {
      var qualityLevels = player.qualityLevels();

      _this.player.addClass('vjs-qualityselector');

      if (_this.videoFiles && _this.videoFiles.length > 1) {
        // Progressive (mp4) Files
        for (var i = 0; i < _this.videoFiles.length; i++) {
          var videoFile = _this.videoFiles[i];
          var level = qualityLevels.addQualityLevel({
            id: videoFile.id,
            bandwidth: videoFile.bitrate,
            enabled: function enabled(isEnabled) {
              return isEnabled;
            }
          });
          level.label = videoFile.bitrateLabel || level.id;
        }

        addUi(); // Register after first selection is selected to avoid initial change event

        qualityLevels.on('change', qualityChangeHandler);
      } else {
        addUi();
        qualityLevels.on('addqualitylevel', addQualityLevelAdaptive);
      }
    });

    _this.on('dispose', function () {
      var qualityLevels = player.qualityLevels();
      var button = player.controlBar.getChild('QualitySelectorButton');

      if (button) {
        player.controlBar.removeChild(button);
        button.dispose();
      }

      qualityLevels.off('change', qualityChangeHandler);
      qualityLevels.dispose();
      this.videoFiles = null;
      this.options = null;
    }.bind(_assertThisInitialized$2(_this)));

    return _this;
  }

  return QualitySelector;
}(Plugin$4); // Define default values for the plugin's `state` object here.


QualitySelector.defaultState = {}; // Include the version number.

QualitySelector.VERSION = version$1$1; // Register UI components

videojs.registerComponent('QualitySelectorButton', QualitySelectorButton); // Register the plugin with video.js.

videojs.registerPlugin('qualityselector', QualitySelector);

/*! @name @videojs-microsoft/videojs-userpreferences @version 1.0.3 @license MIT */

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose$2(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
} // © Microsoft Corporation. All rights reserved.

/**
 * Helper function used to get a cookie value
 *
 * @param {string} name Name of the cookie
 * @return {string} Return value of the cookie if it is present, empty string otherwise
 */


function getCookie(name) {
  if (document$1 && document$1.cookie) {
    var re = new RegExp('\\b' + name + '\\s*=\\s*([^;]*)', 'i');
    var match = re.exec(document$1.cookie);
    return match && match.length > 1 ? match[1] : '';
  }

  return '';
}
/**
 * Helper function used to set a cookie
 * When expiryDays is equal to -1 it will unset the cookie
 *
 * @param {string} name Cookie name
 * @param {string} value Cookie value
 * @param {number} expiryDays Cookie expiry days
 * @param {string} domain Cookie domain
 * @param {string} path Cookie path
 * @param {boolean} secure Is it a https only cookie
 */


function setCookie(name, value, expiryDays, domain, path, secure) {
  var expiryDate;
  var builder = [name, '=', value];
  var oneDayInMilliseconds = 86400000;

  if (expiryDays) {
    var date = new Date();
    date.setTime(date.getTime() + expiryDays * oneDayInMilliseconds);
    expiryDate = date.toUTCString();
    builder.push(';expires=', expiryDate);
  }

  if (domain) {
    builder.push(';domain=', domain);
  }

  if (path) {
    builder.push(';path=', path);
  } else {
    builder.push(';path=', '/');
  }

  if (secure) {
    builder.push(';secure');
  }

  if (document$1) {
    document$1.cookie = builder.join('');
  }
} // © Microsoft Corporation. All rights reserved.

/**
 * This is settings provider to defined standard interfaces needed
 * for user preferences plugin to read and write the data
 */


var DefaultSettingsProvider = /*#__PURE__*/function () {
  function DefaultSettingsProvider() {}

  var _proto = DefaultSettingsProvider.prototype;
  /**
   * Storing the json object into string format with given key into cookie storage
   * @param {string} key used as cookie name
   * @param {json} json object to be stored into cookie
   */

  _proto.store = function store(key, json) {
    if (key && json) {
      setCookie(key, JSON.stringify(json));
    }
  }
  /**
   * Retrieving the value associated to the given key from cookie storage
   * @param {string} key used as cookie name
   * @return {json} json value associated to given key
   */
  ;

  _proto.retrieve = function retrieve(key) {
    var data = getCookie(key);

    if (data) {
      try {
        return JSON.parse(data);
      } catch (e) {
        return {};
      }
    }

    return {};
  };

  return DefaultSettingsProvider;
}();

var version$5 = "1.0.3";
var Plugin$5 = videojs.getPlugin('plugin'); // Default options for the plugin.

var defaults$6 = {
  preferencesKey: 'vjsusrpref',
  preferences: {
    muted: 'muted',
    volume: 'vol',
    captions: 'cc'
  }
};
/**
 * This plugin works as a user preferences to read and write user preference data
 */

var UserPreferences = /*#__PURE__*/function (_Plugin) {
  _inheritsLoose$2(UserPreferences, _Plugin);
  /**
   * Create a UserPreferences plugin instance.
   *
   * @param  {Player} player
   *         A Video.js Player instance.
   *
   * @param  {Object} [options]
   *         An optional options object.
   *
   *         While not a core part of the Video.js plugin architecture, a
   *         second argument of options is a convenient way to accept inputs
   *         from your plugin's caller.
   */


  function UserPreferences(player, options) {
    var _this; // the parent class will add player under this.player


    _this = _Plugin.call(this, player) || this;

    var self = _assertThisInitialized$1(_this);

    _this.options = videojs.mergeOptions(defaults$6, options);
    var settings = _this.options.settingsProvider;

    if (!settings || !settings.store || !settings.retrieve) {
      settings = new DefaultSettingsProvider();
    }

    _this.setPreference = function (name, data) {
      var key = self.preferencesKey;
      var json = settings.retrieve(key) || {};
      json[name] = data;
      settings.store(key, json);
    };

    _this.getPreferences = function () {
      return settings.retrieve(self.preferencesKey) || {};
    };

    _this.getPreference = function (name) {
      return name ? this.getPreferences()[name] : null;
    };

    var tracks = player.textTracks();

    var languageChangeHandlerBind = _this.languageChangeHandler.bind(_assertThisInitialized$1(_this));

    var volumeChangeHandlerBind = _this.volumeChangeHandler.bind(_assertThisInitialized$1(_this));

    _this.on('dispose', function () {
      self.player.off('volumechange', volumeChangeHandlerBind);
      tracks.removeEventListener('selectedlanguagechange', languageChangeHandlerBind);
    });

    _this.player.on('ready', function () {
      self.restorePreferences();
      self.player.on('volumechange', volumeChangeHandlerBind);
      tracks.addEventListener('selectedlanguagechange', languageChangeHandlerBind);
    });

    return _this;
  }
  /**
   * The key used to store the preferences in settings
   *
   * @readonly
   */


  var _proto = UserPreferences.prototype;
  /**
   * Determine if captions is off or language is changed then store into preference
   */

  _proto.languageChangeHandler = function languageChangeHandler() {
    var items = this.player.controlBar.subsCapsButton.menu.children();
    var lang = 'off';

    for (var i = 0; i < items.length; i++) {
      var track = items[i].track;

      if (track.mode === 'showing' && track.kind === 'captions') {
        lang = track.language;
        break;
      }
    }

    this.setPreference(defaults$6.preferences.captions, lang);
  }
  /**
   * Determine if volume level is changed then store into preference
   */
  ;

  _proto.volumeChangeHandler = function volumeChangeHandler() {
    var preferences = {
      muted: 0
    };

    if (this.player.muted() || this.player.volume() === 0) {
      preferences.muted = 1;
    }

    preferences.vol = this.player.volume() * 100;
    this.setPreference(defaults$6.preferences.muted, preferences.muted);
    this.setPreference(defaults$6.preferences.volume, preferences.vol);
  }
  /**
   * Restore all known preferences from preferences settings (eg: volumne, captions)
   */
  ;

  _proto.restorePreferences = function restorePreferences() {
    var jsonData = this.getPreferences();
    var muted = jsonData[defaults$6.preferences.muted];

    if (typeof this.options.muted === 'boolean') {
      muted = this.options.muted === true ? 1 : 0;
    }

    if (muted === 1) {
      this.player.muted(true);
    } else if (muted === 0) {
      this.player.muted(false);
    }

    this.restoreVolume(jsonData[defaults$6.preferences.volume]);
    this.restoreLanguage(jsonData[defaults$6.preferences.captions]);
  }
  /**
   * Set the volume level between 0 to 100 to player
   * @param  {number} volume
   */
  ;

  _proto.restoreVolume = function restoreVolume(vol) {
    if (vol >= 0) {
      this.player.volume(Math.min(vol, 100) / 100);
    }
  }
  /**
   * Set the caption/subtitles lanugage to player, if language cannot be found in track, it will ignore it
   * @param  {string} lang (eg: en, en-gb)
   */
  ;

  _proto.restoreLanguage = function restoreLanguage(lang) {
    if (lang) {
      var items = this.player.controlBar.subsCapsButton.menu.children();

      for (var i = 0; i < items.length; i++) {
        var item = items[i];

        if (lang === 'off' && item.constructor.name === 'OffTextTrackMenuItem' || item.track.kind === 'captions' && item.track.language === lang) {
          item.track.mode = 'showing';
          break;
        }
      }
    }
  };

  _createClass(UserPreferences, [{
    key: "preferencesKey",
    get: function get() {
      return this.options.preferencesKey || defaults$6.preferencesKey;
    }
  }]);

  return UserPreferences;
}(Plugin$5); // Define default values for the plugin's `state` object here.


UserPreferences.defaultState = {}; // Include the version number.

UserPreferences.VERSION = version$5; // Register the plugin with video.js.

videojs.registerPlugin('userpreferences', UserPreferences);

var version$6 = "1.0.44";

var Plugin$6 = videojs.getPlugin('plugin'); // Default options for the plugin.

var defaults$7 = {};
/**
 * This plugin works as a plugin factory initializing a collection of other inner plugins like FreeWheel, GeoFencing, Telemetry,...
 *
 */

var Pluginfactory = /*#__PURE__*/function (_Plugin) {
  _inheritsLoose$3(Pluginfactory, _Plugin);

  /**
   * Create a Pluginfactory plugin instance.
   *
   * @param  {Player} player
   *         A Video.js Player instance.
   *
   * @param  {Object} [options]
   *         An optional options object.
   *
   *         While not a core part of the Video.js plugin architecture, a
   *         second argument of options is a convenient way to accept inputs
   *         from your plugin's caller.
   */
  function Pluginfactory(player, options) {
    var _this;

    // the parent class will add player under this.player
    _this = _Plugin.call(this, player) || this;
    _this.options = videojs.mergeOptions(defaults$7, options);
    /* Initialize plugins */

    player.microsoftnewsui(_this.options);
    _this.options.qualityId = player.userpreferences(_this.options).getPreference('quality') || _this.options.qualityId;

    _this.update({
      options: _this.options
    });
    /**
     * @memberof Pluginfactory
     * @member {boolean} initialized
     *         The current plugin is initialized.
     * @instance
     */


    Object.defineProperty(_assertThisInitialized$2(_this), 'initialized', {
      get: function get() {
        return true;
      }
    });
    return _this;
  }
  /**
   * Update plugin with the new config.
   * It disposes those updatable plugins and reinitialize them
   *
   * @param  {Object} [config]
   *         An optional configuration for plugins, in following format
   *         {
   *           metadata : {
   *              title: 'video title'
   *              url:'http://stream.com/video.mp4',
   *              type:'video/mp4',
   *              poster:null,
   *              tracks:[<cc files>] }
   *           options: { <plugin options> }
   *         }
   */


  var _proto = Pluginfactory.prototype;

  _proto.update = function update(config) {
    var player = this.player;

    if (this.initialized === true) {
      if (player.hasPlugin('geofencing')) {
        player.geofencing().dispose();
      }

      if (player.hasPlugin('qualityselector')) {
        player.qualityselector().off('qualityLevelChanged', this.handleQualityChanged_);
        player.qualityselector().dispose();
      }

      if (player.hasPlugin('freewheel')) {
        player.freewheel().dispose();
      }

      if (player.hasPlugin('telemetry')) {
        player.telemetry().dispose();
      }
    }

    var newconfig = config || {};
    var videodata = newconfig.metadata || {};
    var pluginconfig = newconfig.options || {};

    if (videodata) {
      if (player.titleBar) {
        player.titleBar.title(videodata.title);
      }

      if (videodata.url && player.src() !== videodata.url) {
        var tracks = videodata.tracks || [];
        var captions = player.textTracks().tracks_.filter(function (t) {
          return t.kind === 'captions';
        });

        for (var i = 0; i < captions.length; i++) {
          player.removeRemoteTextTrack(captions[i]);
        }

        for (var _i = 0; _i < tracks.length; _i++) {
          var track = tracks[_i];
          var trackObj = {
            id: track.id,
            kind: 'captions',
            label: track.label,
            srclang: track.language,
            src: track.url
          };
          player.addRemoteTextTrack(trackObj);
        }

        player.src({
          src: videodata.url,
          type: videodata.type
        });
        player.currentTime(0);
      }
    }

    if (videodata.poster && player.poster() !== videodata.poster) {
      player.poster(videodata.poster);
    }

    player.geofencing({
      isGeofenced: pluginconfig.isGeofenced
    });
    var formatId = pluginconfig.qualityId;
    player.qualityselector({
      qualityId: formatId,
      videoFiles: pluginconfig.videoFiles
    });
    player.qualityselector().on('qualityLevelChanged', this.handleQualityChanged_);
    player.freewheel(pluginconfig.freewheel);
    player.telemetry(pluginconfig.telemetry);
  }
  /**
   * Handle quality changed to store the new quality as user preference
   *
   * @param  {event} [evt]
   *         The event object
   *
   * @param  {Object} [data]
   *         The quality data with new level info set by user from quality selector plugin
   */
  ;

  _proto.handleQualityChanged_ = function handleQualityChanged_(evt, data) {
    var player = data.instance.player;

    if (player.userpreferences) {
      player.userpreferences().setPreference('quality', data.tolevel.id);
    }
  };

  return Pluginfactory;
}(Plugin$6); // Define default values for the plugin's `state` object here.


Pluginfactory.defaultState = {}; // Include the version number.

Pluginfactory.VERSION = version$6; // Register the current plugin with video.js.

videojs.registerPlugin('pluginfactory', Pluginfactory);

export default Pluginfactory;
